import React from 'react'

import { CustomInputSwitch, Label, SwitchContainer } from './toggleSwitch.styled'

interface ToggleSwitchProps {
    checked: boolean
    onChange: (checked: boolean) => void
    label: string
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, label }: ToggleSwitchProps) => (
    <SwitchContainer>
        <CustomInputSwitch checked={checked} onChange={(e) => onChange(e.value)} />
        <Label>{label}</Label>
    </SwitchContainer>
)
